import React from "react"
import { Grid } from "@chakra-ui/react"
import Figure from "./Figure"

export interface FigureGridProps {
  children?: React.ReactNode
  mb?: number
  loading?: boolean
  center?: boolean
  /** Trimmed mode: fixed 6-column single-row grid, caps at 6 children, zero gap with separators */
  trimmed?: boolean
}

const MAX_TRIMMED_FIGURES = 6

function FigureGrid({ children, mb, loading, center = false, trimmed = false }: FigureGridProps) {
  const gap = trimmed ? 2 : { base: 2, xl: 3, "2xl": 4 }
  const gridProps = {
    gap,
    mb: trimmed ? 0 : mb,
    gridTemplateColumns: trimmed
      ? {
          base: "repeat(2, 1fr)",
          sm: "repeat(3, 1fr)",
          md: `repeat(${MAX_TRIMMED_FIGURES}, 1fr)`,
        }
      : {
          base: "1fr",
          sm: "repeat(auto-fill, minmax(250px, 1fr))",
        },
    gridAutoRows: "1fr",
    alignItems: "stretch" as const,
    justifyItems: center ? ("center" as const) : undefined,
  }

  if (loading) {
    return (
      <Grid {...gridProps}>
        {[1, 2, 3, 4].map((i) => (
          <Figure key={i} loading />
        ))}
      </Grid>
    )
  }

  if (trimmed) {
    const items = React.Children.toArray(children).slice(0, MAX_TRIMMED_FIGURES)
    return (
      <Grid {...gridProps}>
        {items}
      </Grid>
    )
  }

  return (
    <Grid {...gridProps} pb="16px">
      {children}
    </Grid>
  )
}

export default FigureGrid
